export function parseCompoundLanguageCode(languageCode: string): {
  baseCode: string;
  operatorName: string | null;
} {
  const idx = languageCode.indexOf('#');
  if (idx === -1) return { baseCode: languageCode, operatorName: null };
  return { baseCode: languageCode.slice(0, idx), operatorName: languageCode.slice(idx + 1) };
}
